  const chartOptionsColumn  ={
   
    chart: {
        type: 'bar',
        
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '50%',
            endingShape: 'rounded',
            borderRadius: 3,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
        },
    },   
    
    stroke: {
        show: true,
        width: 5,
        colors: ['transparent']
    },
 
    fill: {
        opacity: 1
    },
    
   
    yaxis: {
        labels: {
          show: false
        }
      }
  };


  const  chartOptionsRadialBar = {

    chart: {
        type: 'radialBar',
        toolbar: {
          show: true
        }
    },
    plotOptions: {
        radialBar: {
           
            hollow: {
                size: '65%',
            }
        },
    },
    stroke: {
      lineCap: "round",
    },
   
  };

  export {
    chartOptionsRadialBar,
    chartOptionsColumn
  }